import {ModalProps} from "react-bootstrap/Modal";
import {Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {fetchVideoToken} from "../../fetch/RequestVideo";
import {actions} from "../../store/sliceModal";
import WebSocketCamera from "../../component/WebCamSocket/WebSocketCamera";
import {actions as websocket} from "../../store/sliceWebsocket";


const ModalCamera: FC<ModalProps> = (props) => {
    const {show, onHide} = props
    const {title, name} = props.camera
    const dispatch = useDispatch<AppDispatch>();

    const [token, setToken] = useState<boolean>(false);

    useEffect(() => {
        if (show) {
            fetchVideoToken().then(response => {
                if (response.status == 204) {
                    setToken(true)
                } else {
                    dispatch(actions.showError("Доступ запрещен"))
                }
            })
        }
    }, [show])

    const init = useCallback(() => {
        if (show) {
            dispatch(websocket.send({body: "", topic: `/app/cam/${name}`}))
            // dispatch(websocket.send({body: "", topic: `/app/cam`}))
        }
    }, [show])

    return (
        <Modal
            {...props}
            fullscreen={true}
            centered
        >
            <Modal.Header closeButton style={{gap: "10px", padding: "5px 16px"}}>{title}</Modal.Header>
            <Modal.Body>
                 {/*<img style={{width: "100%", height: "100%", objectFit: "contain"}}*/}
                 {/*    src={`${config.videoUrl}/api/video/${urlName}/${token}`}/>*/}
                {token && <WebSocketCamera init={init} name={name} onHide={onHide} sound={true} isClose={true}/>}

            </Modal.Body>
        </Modal>
    )
        ;
}

export default memo(ModalCamera)
